import { c as _c } from "react/compiler-runtime";
import { useState, useCallback } from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';
import { Lookup, LookupOption } from '@/components/ui/lookup';
import { calendarApi } from '@/lib/api/endpoints';
import type { CalendarsQuery } from '@/lib/hooks/useCalendars';
import type { ApiCalendar } from '@/lib/api/types';
import * as _ from 'es-toolkit';
interface CalendarsResponse {
  calendars: ApiCalendar[];
  pagination: {
    limit: number;
    nextCursor: string | null;
    prevCursor: string | null;
    hasMore: boolean;
  };
}
interface CalendarLookupProps {
  value?: LookupOption<ApiCalendar> | null;
  onChange: (value: LookupOption<ApiCalendar> | null) => void;
  calendarType?: string;
  ownerId?: string;
  ownerType?: string;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
}
export function CalendarLookup(t0) {
  const $ = _c(30);
  const {
    value,
    onChange,
    calendarType,
    ownerId,
    ownerType,
    placeholder: t1,
    className,
    disabled
  } = t0;
  const placeholder = t1 === undefined ? "Search calendars..." : t1;
  const [searchQuery, setSearchQuery] = useState("");
  const [isEnabled, setIsEnabled] = useState(false);
  const t2 = searchQuery || undefined;
  const t3 = calendarType || undefined;
  let t4;
  if ($[0] !== ownerId || $[1] !== ownerType || $[2] !== t2 || $[3] !== t3) {
    t4 = {
      search: t2,
      type: t3,
      ownerId,
      ownerType,
      limit: 20
    };
    $[0] = ownerId;
    $[1] = ownerType;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const queryFilters = t4;
  let t5;
  let t6;
  if ($[5] !== queryFilters) {
    t5 = ["calendars-lookup", queryFilters];
    t6 = async t7 => {
      const {
        pageParam
      } = t7;
      const response = await calendarApi.getCalendars(_.merge({
        nextCursor: pageParam
      }, queryFilters));
      return response;
    };
    $[5] = queryFilters;
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  let t7;
  if ($[8] !== isEnabled || $[9] !== t5 || $[10] !== t6) {
    t7 = {
      queryKey: t5,
      queryFn: t6,
      enabled: isEnabled,
      staleTime: 10000,
      getNextPageParam: _temp,
      initialPageParam: ""
    };
    $[8] = isEnabled;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const {
    data,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage
  } = useInfiniteQuery(t7);
  let t8;
  if ($[12] !== data?.pages) {
    const allCalendars = data?.pages.flatMap(_temp2) || [];
    t8 = allCalendars.map(_temp3);
    $[12] = data?.pages;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const options = t8;
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => {
      setIsEnabled(true);
    };
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const handleOpen = t9;
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = query => {
      setSearchQuery(query);
    };
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const handleSearch = t10;
  let t11;
  if ($[16] !== fetchNextPage || $[17] !== hasNextPage || $[18] !== isFetchingNextPage) {
    t11 = () => {
      if (hasNextPage && !isFetchingNextPage) {
        fetchNextPage();
      }
    };
    $[16] = fetchNextPage;
    $[17] = hasNextPage;
    $[18] = isFetchingNextPage;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const handleLoadMore = t11;
  const t12 = isLoading || isFetchingNextPage;
  let t13;
  if ($[20] !== className || $[21] !== disabled || $[22] !== handleLoadMore || $[23] !== hasNextPage || $[24] !== onChange || $[25] !== options || $[26] !== placeholder || $[27] !== t12 || $[28] !== value) {
    t13 = <Lookup value={value} onChange={onChange} onSearch={handleSearch} onLoadMore={handleLoadMore} onOpen={handleOpen} options={options} isLoading={t12} hasMore={hasNextPage} placeholder={placeholder} emptyMessage="No calendars found" className={className} disabled={disabled} />;
    $[20] = className;
    $[21] = disabled;
    $[22] = handleLoadMore;
    $[23] = hasNextPage;
    $[24] = onChange;
    $[25] = options;
    $[26] = placeholder;
    $[27] = t12;
    $[28] = value;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  return t13;
}
function _temp3(calendar) {
  return {
    id: calendar.id,
    label: calendar.name || `Calendar ${calendar.id}`,
    data: calendar
  };
}
function _temp2(page) {
  return page.calendars;
}
function _temp(lastPage) {
  return lastPage.pagination.nextCursor;
}